import { useTranslation } from 'react-i18next';

export default function ProblemsWeSolve() {
  const { t } = useTranslation('common');

  const problems = t('problems.list', { returnObjects: true }) as Array<{
    question: string;
    solution: string;
  }>;

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-bold text-gray-500 tracking-wider uppercase mb-3">
            {t('problems.badge')}
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            {t('problems.title')} <span className="italic">{t('problems.titleItalic')}</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('problems.description')} <strong>{t('problems.descriptionBold')}</strong> {t('problems.descriptionEnd')}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className={`w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br ${
                  index % 3 === 0 ? 'from-amber-500 to-amber-600' : 
                  index % 3 === 1 ? 'from-gray-700 to-gray-900' : 
                  'from-amber-600 to-amber-700'
                } flex-shrink-0`}>
                  <i className="ri-question-line text-2xl text-white"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 leading-tight pt-2">
                  {problem.question}
                </h3>
              </div>
              
              <div className="pl-16">
                <div className="flex items-start gap-3">
                  <i className="ri-arrow-right-line text-amber-600 text-xl flex-shrink-0 mt-0.5"></i>
                  <p className="text-sm text-gray-700 leading-relaxed">
                    {problem.solution}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-amber-600 to-amber-700 rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl font-serif mb-4">
            {t('problems.cta.title')}
          </h3>
          <p className="text-lg mb-8 max-w-2xl mx-auto text-amber-50">
            {t('problems.cta.description')}
          </p>
          <button 
            onClick={() => {
              const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
              if (widget) widget.click();
            }}
            className="bg-white text-amber-700 px-10 py-4 rounded-full font-bold text-base hover:bg-gray-50 transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
          >
            <i className="ri-chat-3-line text-xl"></i>
            {t('problems.cta.button')}
          </button>
        </div>
      </div>
    </section>
  );
}
